// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Change colors in this file to style to your needs on a global level. 
Certain colors are used for different and multiply types of elements. 
For greater control over colors visit each components .scss file. */
.social-media-div {
  font-size: 2em;
}

.icon-button {
  margin-bottom: 10px;
}

.icon-button i {
  color: #ffffff;
  border-radius: 2.6rem;
  cursor: pointer;
  display: inline-block;
  font-size: 1.3rem;
  height: 2.6rem;
  line-height: 2.6rem;
  margin: 0 5px;
  position: relative;
  text-align: center;
  -webkit-user-select: none;
  user-select: none;
  width: 2.6rem;
  margin-bottom: 10px;
  transition: 0.2s ease-in;
}

.facebook i {
  background-color: #3b5998;
}

.linkedin i {
  background-color: #0e76a8;
}

.github i {
  background-color: #333;
}

.gitlab i {
  background-color: #fca326;
}

.google i {
  background-color: #ea4335;
}

.twitter i {
  background-color: #1da1f2;
}

.medium i {
  background-color: #000;
}

.stack-overflow i {
  background-color: #f48024;
}

.kaggle i {
  background-color: #20beff;
}

.instagram i {
  background-color: #c13584;
}

/* Hover Transition */
.twitter i:hover,
.google i:hover,
.gitlab i:hover,
.github i:hover,
.linkedin i:hover,
.facebook i:hover,
.instagram i:hover,
.stack-overflow i:hover,
.kaggle i:hover,
.medium i:hover {
  background-color: #000000;
}

/* Media Query */
@media (max-width: 768px) {
  .social-media-div {
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/_globalColor.scss","webpack://./src/components/socialMedia/SocialMedia.scss"],"names":[],"mappings":"AAAA;;mEAAA;ACEA;EACE,cAAA;AAEF;;AACA;EACE,mBAAA;AAEF;;AACA;EACE,cDOc;ECNd,qBAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EAGA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,wBAAA;AAEF;;AACA;EACE,yBDiDS;AC/CX;;AACA;EACE,yBD8CS;AC5CX;;AACA;EACE,sBD2CO;ACzCT;;AACA;EACE,yBDwCO;ACtCT;;AACA;EACE,yBDqCO;ACnCT;;AACA;EACE,yBDkCQ;AChCV;;AACA;EACE,sBD+BO;AC7BT;;AACA;EACE,yBD4Bc;AC1BhB;;AACA;EACE,yBD0BO;ACxBT;;AACA;EACE,yBDqBU;ACnBZ;;AACA,qBAAA;AACA;;;;;;;;;;EAUE,yBDtEU;ACwEZ;;AACA,gBAAA;AACA;EACE;IACE,kBAAA;EAEF;AACF","sourcesContent":["/* Change colors in this file to style to your needs on a global level. \nCertain colors are used for different and multiply types of elements. \nFor greater control over colors visit each components .scss file. */\n\n// button colors\n$buttonColor: #55198b;\n$buttonHover: #8c43ce;\n$topButtonHover: #000;\n\n// text colors light theme\n$titleColor: #000000;\n$textColor: #000000;\n$subTitle: #868e96;\n$cardSubtitle: #666666;\n$talkCardSubTitle: #7f8287;\n$blogCardTitleColor: #262626;\n\n// text color dark theme\n$textColorDark: #ffffff;\n\n// toggle switch colors\n$toggleCheck: #2196f3;\n$toggleSwitchSliderBG: #ccc;\n\n// githubRepo specific colors\n$githubRepoCardLanguageColorBG: #0000ff;\n$githubRepoCardColor: rgb(88, 96, 105);\n$githubRepoCardRepoCardStatsColor: rgb(106, 115, 125);\n$githubRepoCardRepoNameColor: rgb(36, 41, 46);\n$githubProfileCardLocationTS: #ffebcd;\n$githubProfileCardBorder: #6c63ff;\n\n// light background colors\n$lightBackground1: #fff;\n$lightBackground2: rgb(255, 255, 255);\n$lightBackground3: #f5f2f4;\n$blogCardContainerColor: #586069;\n// dark background colors\n$darkBackground: #171c28;\n\n// light theme box shadows\n$lightBoxShadowDark: rgba(0, 0, 0, 0.2);\n$lightBoxShadow: rgba(0, 0, 0, 0.1);\n$lightBoxShadowDarker: rgba(0, 0, 0, 0.3);\n\n// dark theme box shadows\n$darkBoxShadow: #d9dbdf;\n$darkBoxShadow2: #ffffff;\n\n// linear gradients\n$experienceCardBlurredDivLG: linear-gradient(\n  rgba(0, 0, 0, 0.4),\n  rgba(0, 0, 0, 0.2)\n);\n$experienceCardBannerLG: linear-gradient(\n  rgba(0, 0, 0, 0.7),\n  rgba(0, 0, 0, 0.5)\n);\n\n// borders\n$progressBarBackground: rgb(243, 239, 239);\n$lightBorder1: rgba(211, 211, 211, 0.397);\n$educationCardBorder: #a9a7f9;\n\n// hovers\n$achievementCertificateCardHoverDark: rgba(255, 255, 255, 0.2);\n$blogCardHoverSmallColor: rgba(255, 255, 255, 0.8);\n$headerHoverBG: #f4f4f4;\n$contactDetailHoverTS: #b5b5b5;\n\n// misc backgrounds\n$progressBarSpanBG: #aaa5ff;\n$iconBackground: #333;\n$appHeaderBG: #282c34;\n\n// misc colors\n$skillsColor: #645beb;\n$appLink: #09d3ac;\n\n// social media icons\n$faceBook: #3b5998;\n$linkedin: #0e76a8;\n$github: #333;\n$gitlab: #fca326;\n$google: #ea4335;\n$twitter: #1da1f2;\n$medium: #000;\n$stackoverflow: #f48024;\n$instagram: #c13584;\n$kaggle: #20beff;\n","@import \"../../_globalColor\";\n\n.social-media-div {\n  font-size: 2em;\n}\n\n.icon-button {\n  margin-bottom: 10px;\n}\n\n.icon-button i {\n  color: $textColorDark;\n  border-radius: 2.6rem;\n  cursor: pointer;\n  display: inline-block;\n  font-size: 1.3rem;\n  height: 2.6rem;\n  line-height: 2.6rem;\n  margin: 0 5px;\n  position: relative;\n  text-align: center;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  width: 2.6rem;\n  margin-bottom: 10px;\n  transition: 0.2s ease-in;\n}\n\n.facebook i {\n  background-color: $faceBook;\n}\n\n.linkedin i {\n  background-color: $linkedin;\n}\n\n.github i {\n  background-color: $github;\n}\n\n.gitlab i {\n  background-color: $gitlab;\n}\n\n.google i {\n  background-color: $google;\n}\n\n.twitter i {\n  background-color: $twitter;\n}\n\n.medium i {\n  background-color: $medium;\n}\n\n.stack-overflow i {\n  background-color: $stackoverflow;\n}\n\n.kaggle i {\n  background-color: $kaggle;\n}\n\n.instagram i {\n  background-color: $instagram;\n}\n\n/* Hover Transition */\n.twitter i:hover,\n.google i:hover,\n.gitlab i:hover,\n.github i:hover,\n.linkedin i:hover,\n.facebook i:hover,\n.instagram i:hover,\n.stack-overflow i:hover,\n.kaggle i:hover,\n.medium i:hover {\n  background-color: $textColor;\n}\n\n/* Media Query */\n@media (max-width: 768px) {\n  .social-media-div {\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
